(function () {
    'use strict';

    angular
        .module('oddPublicModule')
        .controller('FieldTemplateController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        /**
         * @property {FieldComponent} component
         */

        var _fieldIndexCalled = false,
            _attachmentFieldIndex;

        // Get record ID
        var keys = Object.keys($scope.record);
        if (keys && keys.length > 0) {
            $scope.recordID = $scope.record[keys[0]].recordID;
        }

        $scope.getAttachmentFieldIndex = function () {
            if (_fieldIndexCalled) {
                return _attachmentFieldIndex;
            } else {
                _attachmentFieldIndex = $scope.ctxtCtrl.componentFieldAttachmentIndex++;
                _fieldIndexCalled = true;
            }
        };

        // Name used for the ng-form name. Overrides TemplateController
        $scope.getFormName = function () {
            return 'attForm' + $scope.field.QuestionID + $scope.getAttachmentFieldIndex();
        };

        $scope.getAttachmentInputName = function (compAttachmentId) {
            return 'attInput' + compAttachmentId;
        };


        //region Date

        $scope.dateAnswerModified = function () {
            $scope.templateSaveAnswer()
        };

        //endregion

    }
})();